import { Appearance, useColorScheme } from 'react-native';

type Scheme = 'light' | 'dark' | null | undefined;

export interface ThemeColors {
  primary: string;
  secondary: string;
  accent: string;
  text: string;
  textSecondary: string;
  textLight: string;
  background: string;
  backgroundSecondary: string;
  surface: string;
  border: string;
  borderLight: string;
  error: string;
  warning: string;
  success: string;
  info: string;
  shadow: string;
  overlay: string;
  // Navigation specific
  tabBarBackground: string;
  tabBarBorder: string;
  headerBackground: string;
  headerText: string;
  white: string;
}

// JadeTrade Brand Colors - Light Theme
// Primary jade green (#00A86B) is the authentic jade gemstone color
const lightTheme: ThemeColors = {
  primary: '#00A86B',       // Jade Green - main brand color
  secondary: '#00875A',     // Darker jade for depth
  accent: '#00D488',        // Bright jade for highlights
  text: '#333333',
  textSecondary: '#555555',
  textLight: '#666666',
  background: '#FFFFFF',
  backgroundSecondary: '#F8F9FA',
  surface: '#FFFFFF',
  border: '#E5E5E5',
  borderLight: '#F0F0F0',
  error: '#F43F5E',
  warning: '#FFA500',
  success: '#00A86B',       // Using jade green for success
  info: '#00D488', // jade green (bright) - no blue in app
  shadow: 'rgba(0, 0, 0, 0.1)',
  overlay: 'rgba(0, 0, 0, 0.5)',
  // Navigation
  tabBarBackground: '#FFFFFF',
  tabBarBorder: '#E5E5E5',
  headerBackground: '#FFFFFF',
  headerText: '#333333',
  white: '#FFFFFF',
};

// JadeTrade Brand Colors - Dark Theme
// Using brighter jade accent (#00D488) for better visibility on dark backgrounds
const darkTheme: ThemeColors = {
  primary: '#00D488',       // Bright jade for dark mode (better contrast)
  secondary: '#00A86B',     // Standard jade as secondary
  accent: '#00F49F',        // Lightest jade for accents
  text: '#FFFFFF',
  textSecondary: '#E0E0E0',
  textLight: '#AAAAAA',
  background: '#1A1A1A',
  backgroundSecondary: '#2D2D2D',
  surface: '#262626',
  border: '#333333',
  borderLight: '#404040',
  error: '#F43F5E',
  warning: '#FFB347',
  success: '#00D488',       // Using bright jade for success in dark mode
  info: '#00D488', // jade green (bright) - no blue in app
  shadow: 'rgba(0, 0, 0, 0.3)',
  overlay: 'rgba(0, 0, 0, 0.7)',
  // Navigation
  tabBarBackground: '#000000',
  tabBarBorder: '#333333',
  headerBackground: '#1A1A1A',
  headerText: '#FFFFFF',
  white: '#FFFFFF',
};

export function useColors(): ThemeColors {
  const colorScheme = useColorScheme();
  const isDark = colorScheme === 'dark';
  
  // return isDark ? darkTheme : lightTheme;
  return darkTheme; // Force dark theme for now
}

// Static theme export for StyleSheet usage
export const getTheme = (scheme?: Scheme): ThemeColors => {
  const isDark = scheme === 'dark' || (scheme === null && Appearance.getColorScheme() === 'dark');
  // return isDark ? darkTheme : lightTheme;
  return darkTheme; // Force dark theme for now
};

export const theme = getTheme(Appearance.getColorScheme());